import type { Router } from 'vue-router';

const STALE_RELOAD_KEY = 'stale-chunk-reload';
const RELOAD_COOLDOWN_MS = 10_000;

const reloadOnce = () => {
  const lastReload = Number(sessionStorage.getItem(STALE_RELOAD_KEY) || '0');

  if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) return;

  sessionStorage.setItem(STALE_RELOAD_KEY, String(Date.now()));
  window.location.reload();
};

export const registerStaleChunkReload = (router: Router) => {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadOnce();
  });

  router.onError((error) => {
    if (error.message.includes("Couldn't resolve component")) {
      reloadOnce();
    }
  });
};
